import { type ServerResponse, axios } from '~/axios'
import { type StoplightColorValue } from '~/utils/types/surveys'

export interface SnapshotFilters {
  survey: { value: number } | null
  hubs?: Array<number | 'ALL'>
  orgs?: Array<number | 'ALL'>
  surveyUsers?: number[]
}

export async function getSnapshots(filters: SnapshotFilters) {
  const query = /* GraphQL */ `
    query familiesSnapshot(
      $surveyDefinition: Long!
      $hubs: [Long]
      $orgs: [Long]
      $surveyUsers: [Long]
      $locationAvailable: Boolean
    ) {
      familiesSnapshot(
        surveyDefinition: $surveyDefinition
        hubs: $hubs
        orgs: $orgs
        surveyUsers: $surveyUsers
        locationAvailable: $locationAvailable
      ) {
        page
        totalElements
        additionalData
        content {
          id
          familyName
          familyCode
          latitude
          longitude
          snapshotDate
          stoplight {
            codeName
            value
          }
        }
      }
    }
  `

  return await axios<
    ServerResponse<{
      familiesSnapshot: {
        page: number
        totalElements: number
        additionalData: {
          distinctFamilies: number
        }
        content: Array<{
          id: number
          familyName: string
          familyCode: string
          latitude: string
          longitude: string
          /**
           * NOTE: Timestamp is in seconds
           */
          snapshotDate: number
          stoplight: Array<{
            codeName: string
            value: StoplightColorValue
          }>
        }>
      }
    }>
  >({
    method: 'post',
    url: '/graphql',
    data: {
      query,
      variables: {
        surveyDefinition: filters.survey?.value ?? 0,
        hubs: filters.hubs,
        orgs: filters.orgs,
        surveyUsers: filters.surveyUsers,
        locationAvailable: true,
      },
    },
  })
}

export interface OfflineMap {
  center: [number, number]
  from: [number, number]
  id: number
  name: string
  to: [number, number]
}

export async function listOfflineMapsByOrg(organizationId: number) {
  const query = /* GraphQL */ `
    query SearchOfflineMaps($organizationId: Long) {
      searchOfflineMaps(organization: $organizationId) {
        id
        name
        from
        to
        center
      }
    }
  `

  return await axios<ServerResponse<{ searchOfflineMaps: OfflineMap[] }>>({
    method: 'post',
    url: '/graphql',
    data: { query, variables: { organizationId } },
  })
}
